<div style="box-sizing: border-box; display: flex; flex: 1 1 0%; flex-direction: row; place-content: stretch center; align-items: stretch; height:100%">
  <div style="box-sizing: border-box; display: flex; flex: 1 1 84%; max-width: 50%; flex-direction: column; place-content: stretch center; align-items: stretch;">

    <div style="box-sizing: border-box; display: flex; flex: 1 1 8%;">
    </div>
    <div style="box-sizing: border-box; display: flex; flex: 1 1 84%; flex-direction: column">
      <div style="flex: 1 1 0%; box-sizing: border-box;">
        <lex-case-details style="flex: 1 1 0%; box-sizing: border-box;" [currentCase]="currentCase"></lex-case-details>
      </div>
    </div>
    <div style="box-sizing: border-box; display: flex; flex: 1 1 8%;">
    </div>
  </div>
</div>
